<template>
  <DeviceSetupSection>
    <template v-slot:left>
      <PageContainer
        :class="$style.container"
      >
        <template v-slot:body>
          <Container>
            <HeadingLarge>
              {{ selectedInstall.header }}
            </HeadingLarge>
            <AgentSetupIntro
              v-if="currentStep === 1"
              :agentUrl="agentUrl"
              :compatibilityNotes="compatibilityNotes[selectedOs]"
              :label="settings.label"
            />
            <AgentSetupConnectKey
              v-else-if="currentStep === 2"
              :connectKey="connectKey"
            />
            <DeviceSetupSuccess
              v-else
              subheader="You can fill out more details about this device later."
            />
          </Container>
        </template>

        <template v-slot:footer>
          <Container>
            <ButtonGroupSave
              :isFullWidth="false"
              :primaryButtonProps="primaryButtonProps"
              :secondaryButtonProps="secondaryButtonProps"
              @primaryAction="handleNext"
              @secondaryAction="secondaryAction"
            />
          </Container>
        </template>
      </PageContainer>
    </template>
    <template v-slot:right>
      <div
        :class="[$style.image, $style.center]"
        :style="{ backgroundImage }"
      />
    </template>
  </DeviceSetupSection>
</template>

<script>
import * as Constants from 'client/util/Constants';
import {
  ButtonGroupSave,
  Container,
  HeadingLarge,
  PageContainer,
} from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import AgentSetupConnectKey from 'client/Discover/components/GuidedSetup/AgentSetupConnectKey.vue';
import AgentSetupIntro from 'client/Discover/components/GuidedSetup/AgentSetupIntro.vue';
import CreateSystemMixin from 'client/systems/CreateSystemMixin';
import DeviceSetupSection from 'client/Discover/components/GuidedSetup/DeviceSetupSection.vue';
import DeviceSetupSuccess from 'client/Discover/components/GuidedSetup/DeviceSetupSuccess.vue';
import GuidedSetupMixin from 'client/Discover/components/GuidedSetup/mixins/GuidedSetupMixin';

const {
  ItemTypeConsts,
  StoreModuleMap,
  SystemCompatibilityConsts,
} = Constants;
const { mac, windows } = Constants.default;
const { settings } = ItemTypeConsts;
const settingsModule = StoreModuleMap[settings];

export default {
  name: 'AgentSetup',

  components: {
    AgentSetupConnectKey,
    AgentSetupIntro,
    ButtonGroupSave,
    Container,
    DeviceSetupSection,
    DeviceSetupSuccess,
    PageContainer,
    HeadingLarge,
  },

  mixins: [
    CreateSystemMixin,
    GuidedSetupMixin,
  ],

  computed: {
    ...mapState(settingsModule, [
      'macAgentUrl',
      'windowsAgentUrl',
    ]),

    agentUrl() {
      return this.selectedOs === mac ? this.macAgentUrl : this.windowsAgentUrl;
    },

    compatibilityNotes() {
      return {
        [mac]: {
          header: 'Supported Operating Systems',
          kbLink: this.kbLink,
          text: SystemCompatibilityConsts.mac,
        },
        [windows]: {
          header: 'Supported Operating Systems',
          kbLink: this.kbLink,
          text: SystemCompatibilityConsts.windows,
        },
      };
    },
  },
};
</script>

<style scoped module>
@import './css/guided-setup.css';
</style>
